import { AsyncComponent } from '@frontend/components/common';
import { ProductType } from '@frontend/product/types';
import { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';

import ProductCreateRedirect from '../product/product-create/product-create-redirect.component';

const ProductKitDetail = lazy(() => import('./product-kit-detail/product-kit-detail.component'));
const ProductKitUpdate = lazy(() => import('./product-kit-update/product-kit-update.component'));

export function ProductKitRoutes() {
    return (
        <Route path='product-kits'>
            <Route
                index
                element={
                    <Navigate
                        to='../products?tab=kit'
                        replace
                    />
                }
            />
            <Route
                path='create'
                element={<ProductCreateRedirect type={ProductType.KIT} />}
            />
            <Route path=':productKitId'>
                <Route
                    path='detail'
                    element={
                        <AsyncComponent>
                            <ProductKitDetail />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='update'
                    element={
                        <AsyncComponent>
                            <ProductKitUpdate />
                        </AsyncComponent>
                    }
                />
            </Route>
        </Route>
    );
}
